import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page}  subheading="v2.0">✨ Enhance With AI Settings</PageHeader>

        <TextRow {...page} >In order to enhance bot responses, you have the option to use various Large Language Models (LLMs) in customer conversations. LLMs can help to make responses feel more human and personal, can be used to keep context throughout an entire conversation, and can help keep conversations more interesting. <br></br><br></br> </TextRow>
             
        <TextRow {...page} >LLMs do have a tendency to "hallucinate", which can often cause a conversation to go off the rails. To enhance the accuracy and reliability of the generative Al models, we utilize content from your Property Manager, in real-time, to generate responses that limit hallucinations while being more conversational. <br></br><br></br></TextRow>
        <TextRow {...page} >Due to the inherent variability and unpredictability of LLMs, we advise that while they can be highly effective in customer-facing roles, their responses can sometimes deviate from expected outcomes. </TextRow>
        <SectionHeader {...page}  subheading=""> Use LLM Agents To ... </SectionHeader>
        <SwitchRow {...page}  keyName= {LocationVarKey.LLMAIStorageConsultant} label="Direct conversations with potential customers as a sales development representative" />
        <SwitchRow {...page}  keyName= {LocationVarKey.LLMAICustomerSupportRep} label="Direct conversations with existing customers as a customer support representative" />


        <SectionHeader {...page}  subheading=""> Use LLMs When ... </SectionHeader>
        

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisSizing} label="Making Size Recommendations" />
        
        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisStoreSpecific} label="Providing Store-Specific Information" />

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisUnhandled} label="Replying to Unhandled Questions" />

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisSuggestingPostalCode} label="Suggesting Postal Codes" />
        
        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisAccess} label="Helping with Access Related Interactions"/>

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisAccountManagement} label="Helping Answer Account Related Questions" />
            

            <Indent {...page} ><SwitchRow {...page}  keyName= {LocationVarKey.LLMAccountBillingDispute} label="Billing Dispute" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisAccountManagement,"1")}/></Indent>


        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisFeatures} label="Responding to Feature Related Questions"/>
            

 
        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisIssueResolution} label="Dealing with Issue Resolution" />

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisLease} label="For Lease Term Related Inquiries" />

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisPricing} label="Responding To Pricing Related Questions" />

    </>
}